import { IEventAggregationService } from '@studyportals/event-aggregation-service-interface';
import { AnonymousStudentServiceReady } from '../../interfaces/events';
import { AnonymousStudentService } from '../application/anonymous-student-service';
import { StudentRepository } from '../domain/student-repository';

export class AnonymousStudentInitializer  {
	public initialize(): void {
		this.initializeStudentRepository();
	}
	private initializeStudentRepository(): void {
		const studentRepository = new StudentRepository(this.eventAggregationService);
		const anonymousStudent = new AnonymousStudentService(studentRepository);
		window['AnonymousStudent'] = anonymousStudent;
		studentRepository.initialize();
		const anonymousStudentServiceReadyEvent = new AnonymousStudentServiceReady(anonymousStudent);
		this.eventAggregationService.publishTo(AnonymousStudentServiceReady.EventType, anonymousStudentServiceReadyEvent);
	}

	private get eventAggregationService(): IEventAggregationService  {
		//eslint-disable-next-line @typescript-eslint/no-unsafe-return
		return window['EventAggregationService'];
	}
}